import { arrayMove } from '@dnd-kit/sortable';

export const END_DROP_ID = '__avFiltersEndSlot__';
export const POINTER_ACTIVATION_DISTANCE_PX = 5;

/**
 * Pure reordering for the filter chip list.
 *
 * Returns the input array unchanged when the move is a no-op (active === over,
 * unknown ids, or move resolves to the same slot). When `overId` is the
 * end-of-list sentinel, the active id is moved to the tail.
 */
export const reorderFilters = (order: string[], activeId: string, overId: string): string[] => {
  if (!activeId || !overId || activeId === overId) {
    return order;
  }

  const oldIndex = order.indexOf(activeId);
  if (oldIndex === -1) {
    return order;
  }

  const newIndex = overId === END_DROP_ID ? order.length - 1 : order.indexOf(overId);
  if (newIndex === -1 || newIndex === oldIndex) {
    return order;
  }

  return arrayMove(order, oldIndex, newIndex);
};
